module.exports = __webpack_public_path__ + "static/media/repair_head_wheel.c7d0c267.jpg";